<script>
import getSecret from '@utils/get-secret'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import BaseDatatable from '@components/base-datatable'
import { required, maxLength } from 'vuelidate/lib/validators'
import { periodicTasksResultsMethods } from '@state/helpers'
// import PeriodicTasksForm from "@views/scheduled_tasks/periodic_tasks/create-form";

var colors = {
  hex: '#194d33',
  a: 1
}


export default {
  page: {
    title: 'Scheduled tasks/Executions',
    meta: [{ name: 'description', content: 'Scheduled tasks/Executions' }],
  },
  components: { Layout, PageHeader, BaseDatatable },
  data() {
    return {
      title: 'Scheduled tasks/Executions',
      items: [
        {
          text: 'Home',
          href: '/',
        },
        {
          text: 'Scheduled tasks/Executions',
          active: true,
        },
      ],
      tableHeaders: [
        { key: 'date_created', label: 'Fecha creación'},
        // { key: 'task_intance_name', label: 'Tarea'},
        { key: 'task_name_verbose', label: 'Tarea'},
        { key: 'status', label: 'Estado'},
        { key: 'date_done', label: 'Fecha finalización'},
        { key: 'total_time', label: 'Tiempo ejecución'},
        { key: 'actions', label: this.$t('basic.actions')},
      ],
      action : '',
      form: {
        name: "",
        task: "",
        interval: null,
        crontab: "",
        solar: null,
        clocked: null,
        args: "[]",
        kwargs: "{}",
        queue: null,
        exchange: null,
        routing_key: null,
        headers: "{}",
        priority: null,
        expires: null,
        expire_seconds: null,
        one_off: false,
        start_time: null,
        enabled: true,
        description: ""
      },
      createUpdateModal: {
        id: 'create-update-modal',
        title: '',
        content: ''
      },
      detailModal: {
        id: 'info-modal',
        title: '',
        content: ''
      },
      toDelete: {},
      createUpdateModalShow: false,
      detailModalShow: false,
      deleteModalShow: false,
      isSubmitting: false,
      actionsLoadings: {},
    }
  },
  validations: {
    form: {
      name: {
        required,
        maxLength: maxLength(150)
      },
      task: {},
      interval: {},
      crontab: {},
      solar: {},
      clocked: {},
      args: {},
      kwargs: {},
      queue: {},
      exchange: {},
      routing_key: {},
      headers: {},
      priority: {},
      expires: {},
      expire_seconds: {},
      one_off: {},
      start_time: {},
      enabled: {},
      description: {},
    },
  },
  methods: {
    ...periodicTasksResultsMethods,

    myProvider(ctx) {
      const promise = this.fetchPeriodicTasksResults(this.$table_params(ctx))
      return promise.then(data => {
        return data
      }).catch(error => {
        this.$axios_error_noty(error, this)
        console.log(error)
        return [] 
      })
    },
    openDetailModal(item, index, button) {
      let context = this
      context.isSubmitting = true
      context.actionsLoadings[button] = true
      context.detailModal.title = `Tarea: ${item.task_id}`
      const promise = context.fetchPeriodicTasksResultsDetail(item.url)
      return promise.then(data => {
        context.detailModal.content = data
        context.detailModalShow = !context.detailModalShow
        context.isSubmitting = false
        context.actionsLoadings[button] = false
      }).catch(error => {
        context.$axios_error_noty(error, context)
        context.isSubmitting = false
        context.actionsLoadings[button] = false
      })
    },
    resetdetailModal() {
      this.detailModal.title = ''
      this.detailModal.content = ''
    },

    onFormSubmit(evt, data) {
      let context = this
      context.isSubmitting = true
      evt.preventDefault()
      if (context.$v.form.$anyError) {
        context.$v.form.$touch()
      }
      let form = context.form
      let dataForm = { ...form, ...data }
      const promise = context.createUpdatePeriodicTasks(dataForm)
      return promise.then(data => {
        if (form.url){
          context.$generate_toast(context, 'success', context.$t('alerts.updated_successfully'))
        }else{
          context.$generate_toast(context, 'success', context.$t('alerts.created_successfully'))
        }
        context.createUpdateModalShow = !context.createUpdateModalShow
        context.$refs.table.refresh()
        context.isSubmitting = false
      }).catch(error => {
        context.$axios_error_noty(error, context)
        context.isSubmitting = false
      })
    },
    openDeleteModal(item, index) {
      this.toDelete = item
      this.deleteModalShow = !this.deleteModalShow
    },
    resetDeleteModal(item, index) {
      this.toDelete = {}
    },    
    deleteSubscription() {
      let context = this
      context.isSubmitting = true
      const promise = context.deletePsSubscriptions(context.toDelete.url)
      return promise.then(data => {
        context.$generate_toast(context, 'success', context.$t('alerts.deleted_successfully'))
        context.$refs.table.refresh()
        context.isSubmitting = false
      }).catch(error => {
        context.$axios_error_noty(error, context)
        context.isSubmitting = false
      })
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-container fluid class="p-0">
      <b-row>
        <b-col>
          <b-card >
            <!-- <b-button
              variant="primary"
              size="sm"
              @click="openCreateUpdateModal(null, null, 'create')"
              >
              <i class="fad fa-plus"></i> Crear
            </b-button> -->
            
            <BaseDatatable
              ref="table"
              :drfprovider="myProvider"
              :tableheaders="tableHeaders"
              >
              <!-- <template v-slot:cell(task_intance_name)="row">
                {{ row.item.task_instance ? row.item.task_instance.name : row.item.task_name_verbose }}
              </template> -->
              <template v-slot:cell(status)="row">
                <span
                  v-if="row.value === 'SUCCESS'"
                  class="fad fa-circle-check text-success"
                ></span>
                <span
                  v-if="row.value === 'PENDING'" 
                  class="fe-clock text-warning"
                ></span>
                <span
                  v-if="row.value !== 'SUCCESS' && row.value !== 'PENDING'"
                ><i class="fad fa-circle-xmark text-danger"></i>{{row.value}}</span>
              </template>
              <template v-slot:cell(date_done)="row">
                {{$strfDatetime(row.value)}}
              </template>
              <template v-slot:cell(date_created)="row">
                {{$strfDatetime(row.value)}}
              </template>
              <template v-slot:cell(total_time)="row">
                <span v-if="row.item.date_done">{{ $datetimesDiff(row.item.date_created, row.item.date_done) / 1000 }} s.</span>
              </template>
              
              <template v-slot:cell(actions)="row">
                <b-button-group size="xs">
                  <b-button
                    :id="`info-btn-${row.index}`"
                    v-b-tooltip.hover="{ variant: 'info', placement: 'leftbottom', title:'Info'}"
                    variant="btn-link text-info btn-transparent"
                    size="xs"
                    :disabled="isSubmitting || actionsLoadings[`info-btn-${row.index}`]"
                    @click="openDetailModal(row.item, row.index, `info-btn-${row.index}`)"
                    >
                    <i v-if="!actionsLoadings[`info-btn-${row.index}`]" class="fad fa-circle-info fe-2x"></i>
                    <b-spinner
                      v-if="actionsLoadings[`info-btn-${row.index}`]"
                      small
                      label="Spinning"
                      variant="info"
                      >
                    </b-spinner>
                  </b-button>

                  <!-- <b-button
                    :id="`update-btn-${row.index}`"
                    :disabled="isSubmitting"
                    v-b-tooltip.hover="{ variant: 'warning', placement: 'leftbottom', title:'Edit'}"
                    variant="btn-link text-warning btn-transparent"
                    size="xs"
                    @click="openCreateUpdateModal(row.item, row.index, 'update')"
                    >
                    <i class="fad fa-pen fe-2x"></i>
                  </b-button>

                  <b-button
                    :id="`delete-btn-${row.index}`"
                    :disabled="isSubmitting"
                    v-b-tooltip.hover="{ variant: 'danger', placement: 'leftbottom', title:'Delete'}"
                    variant="btn-link text-danger btn-transparent"
                    size="xs"
                    @click="openDeleteModal(row.item, row.index)"
                    >
                    <i class="fad fa-trash-xmark"></i>
                  </b-button> -->

                </b-button-group>
              </template>
              </BaseDatatable>
            </b-card>
        </b-col>
      </b-row>
    </b-container>
    <!-- Detail modal -->
    <b-modal 
      :id="detailModal.id"
      v-model="detailModalShow"
      ok-only
      size="xl"
      :title="detailModal.title"
      @hide="resetdetailModal"
      >
      <!--{{ detailModal.content }}-->
      <b-tabs v-if="detailModal.content.id">
        <b-tab title="Información general">
          <b-container fluid>
            <b-row>
              <b-col md="6">
                <table class="table-hover table-sm mb-0 table-responsive" style="table-layout: fixed;width:100%">
                  <tr><th style="text-align:right">ID tarea </th><td>{{ detailModal.content.task_id }} </td></tr>
                  <tr><th style="text-align:right">Tarea </th><td>{{ detailModal.content.task_name_verbose }} - ({{ detailModal.content.task_name }}) </td></tr>
                  <tr><th style="text-align:right">Estado </th><td>{{ detailModal.content.status }} </td></tr>
                  <tr><th style="text-align:right">Fecha creación </th><td>{{ $strfDatetime(detailModal.content.date_created) }} </td></tr>
                  <tr><th style="text-align:right">Fecha finalización </th><td>{{ $strfDatetime(detailModal.content.date_done) }} </td></tr>
                  <tr><th style="text-align:right">Tiempo ejecución </th><td><span v-if="detailModal.content.date_done">{{ $datetimesDiff(detailModal.content.date_created, detailModal.content.date_done) / 1000 }} segundos</span></td></tr>
                  <tr><th style="text-align:right">Resultado </th><td>{{ detailModal.content.result }} </td></tr>
                </table>
              </b-col>
              <b-col md="6">
                <b-card
                  header-bg-variant="primary"
                  header-text-variant="white"
                  header="Resultados de la ejecución"
                  footer-bg-variant="light"
                  class="border border-primary"
                >
                  <pre v-if="detailModal.content.result">{{ JSON.stringify(JSON.parse(detailModal.content.result), null, 2) }}</pre>
                </b-card>
              </b-col>
            </b-row>
          </b-container>
        </b-tab>
        <b-tab title="Información técnica">
            <b-container fluid>
              <b-row>
                <b-col md="12">
                  <table v-if="detailModal.content.id" class="table-hover table-sm mb-0 table-responsive" style="table-layout: fixed;width:100%">
                    <tr><th style="text-align:right">Args </th><td>{{ detailModal.content.task_args }} </td></tr>
                    <tr><th style="text-align:right">Kwargs </th><td>{{ detailModal.content.task_kwargs }} </td></tr>
                    <tr><th style="text-align:right">Worker </th><td>{{ detailModal.content.worker }} </td></tr>
                    <tr><th style="text-align:right">Codificación contenido </th><td>{{ detailModal.content.content_type }} </td></tr>
                    <tr><th style="text-align:right">Codificación texto </th><td>{{ detailModal.content.content_encoding }} </td></tr>
                    <tr><th style="text-align:right">traceback </th><td>{{ detailModal.content.traceback }} </td></tr>
                    <tr><th style="text-align:right">meta </th><td>{{ detailModal.content.meta }} </td></tr>
                  </table>
                </b-col>
              </b-row>
            </b-container>
          </b-tab>
      </b-tabs>

    </b-modal>

    <b-modal 
      :id="createUpdateModal.id"
      v-model="createUpdateModalShow"
      :title="createUpdateModal.title"
      :size="action === 'create' ? 'lg' : 'lg'"
      >
      <!-- <PeriodicTasksForm 
        v-if="action === 'create'" 
        :validator="$v.form"
        :onformsubmit="onFormSubmit"
        :action="action"
        :form="form">
      </PeriodicTasksForm>
      <PeriodicTasksForm 
        v-if="action === 'update'"
        :action="action"
        :validator="$v.form"
        :onformsubmit="onFormSubmit"
        :form="form">
      </PeriodicTasksForm> -->
      
      <template v-slot:modal-footer>
          <b-button
            type="cancel"
            variant="secondary"
            size="sm"
            class="float-right"
            @click="createUpdateModalShow = !createUpdateModalShow"
          >
          {{ $t('basic.cancel') }}
        </b-button>
        <b-button
          type="submit"
          form="form"
          size="sm"
          variant="primary"
          :disabled="$v.form.$invalid || isSubmitting"
        >
          <span v-if="!isSubmitting">{{ $t('submit') }}</span>
          <b-spinner v-if="isSubmitting" small label="Spinning" variant="light"></b-spinner>
        </b-button>
      </template>
    </b-modal>

    <!-- Delete modal -->
    <b-modal
      id="delete-modal"
      v-model="deleteModalShow"
      title="Delete subscription"
      :ok-title="$t('basic.delete')"
      ok-variant="danger"
      @hidden="resetDeleteModal"
      @ok="deleteSubscription"
      >
      <p>
        Are you sure you want to delete the platform subscription named {{ toDelete ? toDelete.name  : '' }} ?
      </p>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button size="sm" variant="secondary" @click="cancel">
          {{ $t('basic.cancel') }}
        </b-button>
        <b-button
          size="sm"
          variant="danger"
          :disabled="isSubmitting"
          @click="ok">
          <span
            v-if="!isSubmitting"
            >
            {{ $t('delete') }}
          </span>
          <b-spinner
            v-if="isSubmitting"
            small
            label="Spinning"
            variant="light"
            >
          </b-spinner>
        </b-button>
      </template>
    </b-modal>
  </Layout>
</template>
